export default "__VITE_ASSET__CJNyw8rV__"